import { IJackpotViewModel } from "@/fe-core/meta/interfaces/eligibleJackpots";
import { IErrorPayload } from "@/fe-core/meta/interfaces/root";
import {
  CloseJackpotModalAction,
  eligibleJackpotActionTypes,
  GetEligibleJackpotsFailureAction,
  GetEligibleJackpotsRequestAction,
  GetEligibleJackpotsSuccessAction,
  OpenJackpotModalAction,
  UpdateJackpotsDataAction,
} from "@/fe-core/meta/types/eligibleJackpots";

export const getEligibleJackpotsRequest =
  (): GetEligibleJackpotsRequestAction => ({
    type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_REQUEST,
  });

export const getEligibleJackpotsSuccess = (
  payload: IJackpotViewModel[]
): GetEligibleJackpotsSuccessAction => ({
  type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_SUCCESS,
  payload,
});

export const getEligibleJackpotsFailure = (
  payload: IErrorPayload
): GetEligibleJackpotsFailureAction => ({
  type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_FAILURE,
  payload,
});

export const updateJackpotsData = (
  payload: IJackpotViewModel
): UpdateJackpotsDataAction => ({
  type: eligibleJackpotActionTypes.UPDATE_JACKPOTS_DATA,
  payload,
});

export const openJackpotModal = (): OpenJackpotModalAction => ({
  type: eligibleJackpotActionTypes.OPEN_JACKPOT_MODAL,
});

export const closeJackpotModal = (): CloseJackpotModalAction => ({
  type: eligibleJackpotActionTypes.CLOSE_JACKPOT_MODAL,
});
